var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClasses = function SvgClasses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M62 12H18a6 6 0 0 0-6 6v44a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V18a6 6 0 0 0-6-6m-44-2a8 8 0 0 0-8 8v44a8 8 0 0 0 8 8h44a8 8 0 0 0 8-8V18a8 8 0 0 0-8-8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M62 18H18v22h44zm-44-2a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V18a2 2 0 0 0-2-2zM28 50H18v10h10zm-10-2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V50a2 2 0 0 0-2-2zM36 49a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H37a1 1 0 0 1-1-1M36 55a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H37a1 1 0 0 1-1-1M36 61a1 1 0 0 1 1-1h26a1 1 0 1 1 0 2H37a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36 35V23l9 6z"
  })));
};
export default SvgClasses;